//Components
import SurveyShortQuestion from "../SurveyQuestionTypes/SurveyShortQuestion/SurveyShortQuestion";
import SurveyLongQuestion from "../SurveyQuestionTypes/SurveyLongQuestion/SurveyLongQuestion";
import SurveyDateQuestion from "../SurveyQuestionTypes/SurveyDateQuestion/SurveyDateQuestion";
import SurveyTimeQuestion from "../SurveyQuestionTypes/SurveyTimeQuestion/SurveyTimeQuestion";
import SurveyMultipleChoiceQuestion from "../SurveyQuestionTypes/SurveyMultipleChoiceQuestion/SurveyMultipleChoiceQuestion";
import SurveySingleChoiceQuestion from "../SurveyQuestionTypes/SurveySingleChoiceQuestion/SurveySingleChoiceQuestion";
import SurveyRangeQuestion from "../SurveyQuestionTypes/SurveyRangeQuestion/SurveyRangeQuestion";
import SurveyRankingQuestion from "../SurveyQuestionTypes/SurveyRankingQuestion/SurveyRankingQuestion";
import GroupReferenceQuestion from "../SurveyQuestionTypes/GroupReferenceQuestion/GroupReferenceQuestion";

//Mui Components
import { Paper, Typography } from "@mui/material";
//Hooks
import { useRef, useEffect } from "react";
//Custom css
import "./SurveyQuestionCard.css";

const SurveyQuestionCard = ({ index, question, onChangeAlert, disabled }) => {
  const { type, title, id, variant, error, required, image } = question;
  const elementRef = useRef(null);
  const isGroupReference = type?.value === "groupreference";

  const getQuestionBody = () => {
    switch (type?.value) {
      case "longanswer": {
        return (
          <SurveyLongQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }

      case "date": {
        return (
          <SurveyDateQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }

      case "time": {
        return (
          <SurveyTimeQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }
      case "multiplechoice": {
        return (
          <SurveyMultipleChoiceQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }

      case "singlechoice": {
        if (variant?.value === "range") {
          return (
            <SurveyRangeQuestion
              question={question}
              disabled={disabled}
              onChangeAlert={onChangeAlert}
            />
          );
        }
        return (
          <SurveySingleChoiceQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }

      case "ranking": {
        return (
          <SurveyRankingQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }

      case "groupreference": {
        return (
          <GroupReferenceQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }

      default: {
        return (
          <SurveyShortQuestion
            question={question}
            disabled={disabled}
            onChangeAlert={onChangeAlert}
          />
        );
      }
    }
  };

  const questionBody = getQuestionBody();

  //Scroll to center when error
  useEffect(() => {
    if (elementRef?.current && error) {
      setTimeout(() => {
        elementRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }, 200);
    }
  }, [elementRef, error]);

  return (
    <Paper
      id={`survey-question-card-${id}`}
      className={`survey-question__card ${
        error && "survey-question__card--error shake "
      } ${isGroupReference ? "survey-question__group-reference" : ""}`}
      ref={elementRef}
    >
      <div className="survey-question__card-header">
        {!isGroupReference ? (
          <>
            <Typography className="text-bold text-uppercase">
              Q{index}.
            </Typography>
            <p className="survey-question-title" style={{ marginTop: "4px" }}>
              {title}
              {required && <span className="survey-question__required">*</span>}
            </p>
          </>
        ) : (
          <>
            <Typography className="survey-question__group-reference--title">
              {title}
            </Typography>
          </>
        )}
      </div>

      {image && (
        <img
          className="survey-question__image"
          src={image}
          alt={title}
          draggable="false"
        />
      )}
      <div className="survey-question__card-body">{questionBody}</div>
    </Paper>
  );
};

export default SurveyQuestionCard;
